import { render, staticRenderFns } from "./Obituaries.vue?vue&type=template&id=2b260eab&scoped=true"
import script from "./Obituaries.vue?vue&type=script&lang=js"
export * from "./Obituaries.vue?vue&type=script&lang=js"
import style0 from "./Obituaries.vue?vue&type=style&index=0&id=2b260eab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b260eab",
  null
  
)

export default component.exports